// Shown when the API refuses the kitchen display with PLAN_FEATURE_LOCKED
// (docs/plan-limits-plan.md §7). Same look as the router's ForbiddenPage.

export function PlanLockedPage() {
  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen bg-neutral-950 p-4"
      data-testid="kds-plan-locked"
    >
      <div className="w-16 h-16 rounded-2xl bg-warning-500/20 flex items-center justify-center mb-4">
        <svg className="h-8 w-8 text-warning-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0110 0v4" />
        </svg>
      </div>
      <h1 className="text-xl font-bold text-white mb-2">Kitchen display is locked</h1>
      <p className="text-neutral-400 text-sm text-center max-w-sm">
        The kitchen display is not in your plan. Ask your owner to upgrade.
      </p>
    </div>
  );
}
